/*
* Note: dropdown only shown in pdf mode if a mix of renderable and non-renderable pgs' in viewer.
* This view is the content of the dropdown button.
* */

require('./style.less');

var DropDownContentView = require('../../../../common/dropDown/dropDownContentView'),
    $ = require('jquery'),
    _ = require('underscore');

module.exports = DropDownContentView.extend({

    template: require('./unrenderablePgsPDF.hbs'),

    // Return array of the page model attributes augmented with a few properties.
    // (Originally I just provided the model attributes).
    // Note: unrenderablePDFModePgs are only either GOS or URL page types ...
    // other 'URL' type pages are renderable so the URL portion wouldn't apply here (though the code should be cleaned up
    // here and in the regular unrenderable page views to reflect this ) -- see comments in DVBC-1356.
    templateOptions: function() {

        var vCh = this.options.vChannel,

            aPageModelAttributes =  vCh.request('unrenderablePDFModePgs').map( function(pg) {

                var isGosPageType = pg.hasGosInfo();

                return _.extend( {}, pg.toJSON() , {
                    isGosPageType: isGosPageType,
                    showDownloadButton: isGosPageType && vCh.request('allowPageDownload', pg )
                });

            });

        return {
            pages: aPageModelAttributes
        };

    },
    ui: {
        downloadGosBtn: '.btn-dl',
        popUrlBtn:      '.btn-urlPop'
    },
    events: {
        'click @ui.downloadGosBtn': function(e) {
            var pgNum = $(e.currentTarget).data('pgnum'); // Stored in DOM for now -- really should have item view w/models and loop
            this.options.vChannel.command('download', 'page', 'raw', pgNum);
        },
        'click @ui.popUrlBtn': function(e) {
            var pgNum = $(e.currentTarget).data('pgnum');
            window.open( this.options.vChannel.request('unrenderablePDFModePgs').findWhere({number: pgNum}).getPageUrl() );
        }
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/unrenderablePgDD/unrenderablePgsPDF.js
 ** module id = 726
 ** module chunks = 0
 **/